module.exports = __webpack_public_path__ + "static/screenshot-381a197ac0c61ba22b6f88783894aa65.jpg";